<template>
    <div class="plan-timetravel">
        <h4>Plan Timetravel</h4>
        <f-button type="secondary" @click="handler.action(component['#id'], 'reset_to_starter')">Reset
            Starter</f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], 'one_week_before')">1 week before
            deadline</f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], 'to_the_deadline')">to the deadline
        </f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], '12_hours_after')">12 hours after deadline
        </f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], '7_days_before_removal')">7 days before removal</f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], '1_day_before_removal')">1 day before removal</f-button>
        <f-button type="secondary" @click="handler.action(component['#id'], 'one_month_after')">Removal
            deadline</f-button>
    </div>
</template>
<script>
export default {
    props: ["component", "handler"],
}
</script>
<style lang="scss">
.plan-timetravel {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-direction: column;
    gap: 8px;

    h4 {
        grid-column: 1 / -1;
    }

}
</style>